import type { VFC } from 'react';
import { lazy, Suspense } from 'react';

import type { BurgerMenuLinksProps } from './types';
import { SkeletonMainCategoriesDesktop, SkeletonMainCategoriesMobile } from '~/components/Skeleton';
import { useMobileWidth } from '~/hooks';

const LazyGeneratedBurgerMainMenuLinks = lazy(async () => import('./Links'));

export const BurgerMenuLinks: VFC<BurgerMenuLinksProps> = ({ isBrandPartner }) => {
  const isMobile = useMobileWidth();

  return (
    <Suspense
      fallback={isMobile ? <SkeletonMainCategoriesMobile /> : <SkeletonMainCategoriesDesktop />}
    >
      <LazyGeneratedBurgerMainMenuLinks isBrandPartner={isBrandPartner} />
    </Suspense>
  );
};

export default BurgerMenuLinks;
